import React from 'react'
import '../../styles/style-ind.css'
import { useMediaQuery } from "react-responsive";

const SectionTwo = () => {


    const pricingData = [
        { feature: "Monthly Cost", growth: "Starting ₹3,800", pro: "Starting ₹30,000", enterprise: "Custom" },
        { feature: "Channels", growth: "WhatsApp", pro: "WhatsApp, FB + Insta, SMS + Email", enterprise: "WhatsApp, FB + Insta, SMS + Email" },
        { feature: "Broadcast Campaigns", growth: true, pro: true, enterprise: true },
        { feature: "DIY Automations", growth: true, pro: true, enterprise: true },
        { feature: "Customer Segmentation", growth: true, pro: true, enterprise: true },
        { feature: "Smart Retry", growth: true, pro: true, enterprise: true },
        { feature: "KwikPass Integration", growth: false, pro: true, enterprise: true },
        { feature: "Kwik Insights", growth: false, pro: true, enterprise: true },
        { feature: "AI Calling", growth: false, pro: false, enterprise: true },
        { feature: "Support – Chat Panel", growth: true, pro: true, enterprise: true },
        { feature: "DIY Chatbot Builder", growth: true, pro: true, enterprise: true },
        { feature: "AI Chatbot", growth: false, pro: true, enterprise: true },
        { feature: "Custom Automations", growth: false, pro: true, enterprise: true },
        { feature: "RFM + Cohort Analysis", growth: false, pro: true, enterprise: true },
        { feature: "A/B Testing", growth: false, pro: true, enterprise: true },
        { feature: "Custom Events", growth: false, pro: false, enterprise: true },
        { feature: "Live Segments", growth: false, pro: false, enterprise: true },
        { feature: "App Integrations (e.g., Appbrew)", growth: false, pro: false, enterprise: true },
        { feature: "Dedicated customer success manager", growth: 'Only email support', pro: true, enterprise: true }
    ]



    const tools = [
        {
            title: 'KwikPass',
            desc: `Identify up to 25% anonymous users, enable friction-free one-tap logins, and run high-impact pop-ups that drive conversions and reduce drop-offs`,
            img: '/assets/images/kwikpricing/img1-india.png',
            alt: 'KwikPass preview',

        },
        {
            title: 'Kwik Insights',
            desc: `Get deep, actionable insights from your user behavior and campaign performance to optimize every touchpoint.`,
            img: '/assets/images/kwikpricing/img2-india.png',
            alt: 'Kwik Insights dashboard',

        },
        {
            title: 'AI Calling & Chat',
            desc: `Recover abandoned carts, resolve queries, and re-engage shoppers instantly with AI-powered voice and chat support .`,
            img: '/assets/images/kwikpricing/img3-india.png',
            alt: 'AI Calling & Chat',

        },
        {
            title: 'AI-Powered Retries',
            desc: `Improve message delivery rates by up to 20% with intelligent, AI-driven retry logic that automatically resends failed messages at the right time — no manual effort needed.`,
            img: '/assets/images/kwikpricing/img4-india-inter.png',
            alt: 'AI-Powered Retries',

        }
    ];

    const Cell = ({ value }) => {
        if (typeof value === "boolean") {
            return (
                <img
                    src={value ? "/assets/images/kwikpricing/check.png" : "/assets/images/kwikpricing/cross.png"}
                    alt={value ? "Yes" : "No"}
                    width="18"
                />
            )
        }
        return <span>{value}</span>
    }


    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className='price-ind-three'>
            <div className="pricing-plan">
                <h1 className='price-plan-heading'>Compare Features Across All Plans</h1>
                <p className='price-plan-sub-head'>All the features, clearly laid out, so you pick the plan that fits your goals.</p>

                <div className="pricing-grid">
                    {/* Header */}
                    <div className="pricing-row header" style={{ border: '1px solid #99D5FE' }}>
                        <div style={{ borderBottomLeftRadius: "30px", borderTopLeftRadius: "30px", border: "1px solid #99D5FE", borderRight: 'none' }}>Feature</div>
                        <div style={{ border: "1px solid #99D5FE", borderLeft: 'none', borderRight: 'none' }}>Growth</div>
                        <div style={{ border: "1px solid #99D5FE", borderLeft: 'none', borderRight: 'none' }}>Pro</div>
                        <div style={{ borderBottomRightRadius: "30px", borderTopRightRadius: "30px", border: "1px solid #99D5FE", borderLeft: 'none' }}>Enterprise</div>
                    </div>

                    {/* Data Rows */}
                    {pricingData.map((row, idx) => (
                        <div className="pricing-row" key={idx}>
                            <div>{row.feature}</div>
                            <div><Cell value={row.growth} /></div>
                            <div><Cell value={row.pro} /></div>
                            <div><Cell value={row.enterprise} /></div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="pricing-tools">
                <h1 className="price-plan-heading-tool">Built-in Tools That Set Us Apart</h1>
                <div className="timeline-root">
                    {tools.map((tool, idx) => (
                        <div className="timeline-section" key={tool.title}>
                            <div className="timeline-marker">

                                {!isMobile && idx !== 0 && <div className="timeline-line" />}
                                <div className="timeline-dot" />
                                {idx !== tools.length && <div className="timeline-line timeline-line-down" />}
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-text">
                                    <h2>{tool.title}</h2>
                                    <p>{tool.desc}</p>
                                </div>
                                <div className="timeline-img">
                                    <img src={tool.img} alt={tool.alt} />
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>

        </div>
    )
}

export default SectionTwo
